import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { useHistory } from "react-router-dom";
import { GoogleAuth, LandingLayout, Loading } from "../../components";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import mail from "../../assets/svg/message.svg";
import lock from "../../assets/svg/lock.svg";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Input, Switch } from "antd";
import { Link } from "react-router-dom";
import { ROUTES } from "../../settings/routes";
import { useDispatch, useSelector } from "react-redux";
import { getAuth } from "../../redux/reducers/authReducer";
import { isEmpty, Toast, ValidateEmail } from "../../lib/helpers/helpers";
import { signin } from "../../redux/actions/authentication";

const SigninWrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	.active {
		${tw`bg-appPink`}
	}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const Signin = (props) => {
	const [checked, setChecked] = useState(true);
	const history = useHistory();
	const dispatch = useDispatch();
	const auth = useSelector(getAuth);
	const [loading, setLoading] = useState(false);
	const [fields, setFields] = useState({
		email: "",
		password: "",
		rememberMe: checked,
	});

	const login = (e) => {
		e.preventDefault();

		if (!ValidateEmail(fields.email.trim())) {
			Toast.fire({
				icon: "error",
				title: `You must enter a valid email address`,
			});
			return;
		}

		if (isEmpty(fields.password)) {
			Toast.fire({
				icon: "error",
				title: `Password field is compulsory`,
			});
			return;
		}
		const data = {
			email: fields.email.trim(),
			password: fields.password.trim(),
		};
		if (data.password.length < 8) {
			Toast.fire({
				icon: "error",
				title: `Password must be at least 8 characters`,
			});
			return;
		}
		setLoading(true);
		dispatch(signin(data));
	};

	// console.log(auth);

	useEffect(() => {
		try {
			if (!loading) {
				return;
			}
			setLoading(false);
			const { error, message, title, user } = auth;
			if (error) {
				return Toast.fire({
					icon: "error",
					title: `${!isEmpty(title) ? title + "\n" : ""} ${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `Login successful,
					Welcome back, ${user?.firstname}`,
				});

				setTimeout(() => {
					user.emailVerified
						? history.push({
								pathname: ROUTES.DASHBOARD,
						  })
						: !user.emailVerified
						? history.push({
								pathname: ROUTES.VERIFICATION,
								state: { user },
						  })
						: history.push({
								pathname: ROUTES.ACCOUNTSETUP,
								state: { user },
						  });
				}, 2000);
			}
		} catch (error) {}
		// eslint-disable-next-line
	}, [auth]);
	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col! justify-center!">
				<SigninWrapper>
					<LandingTitle>
						Sign in to <br /> Wedding Story
					</LandingTitle>

					<div tw="w-full pt-4">
						<form tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12">
							<Input
								placeholder="Your email"
								type="email"
								css={inputStyle}
								onChange={(e) => {
									setFields({
										...fields,
										email: e.target.value.trim(),
									});
								}}
								prefix={
									<img
										src={mail}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>
							<Input.Password
								placeholder="Your password"
								type="password"
								css={inputStyle}
								onChange={(e) => {
									setFields({
										...fields,
										password: e.target.value.trim(),
									});
								}}
								prefix={<img src={lock} alt="" tw="pr-2" />}
								iconRender={(visible) =>
									visible ? (
										<EyeTwoTone />
									) : (
										<EyeInvisibleOutlined />
									)
								}
							/>
							<div tw="flex flex-row flex-nowrap justify-between items-center mb-8">
								<span tw="flex flex-row flex-nowrap items-center">
									<Switch
										checked={checked}
										tw="pr-2"
										onChange={() => setChecked(!checked)}
										className={checked ? "active" : ""}
										size="small"
									/>{" "}
									<label tw="text-appTextDark ml-2 text-sm">
										Remember Me
									</label>
								</span>

								<span>
									<Link
										to={ROUTES.FORGOTPASSWORD}
										tw="text-appTextDark font-light text-sm hover:text-appPink">
										Forgot Password?
									</Link>
								</span>
							</div>{" "}
							<button
								css={btnStyle}
								onClick={login}
								disabled={loading}>
								{loading ? <Loading /> : "Sign in"}
							</button>
							<p tw="text-base text-appTextDark opacity-70 text-center mt-6 mb-6">
								or continue with
							</p>
							<div tw="w-full">
								<GoogleAuth />
							</div>
							<div>
								<p tw="text-center text-base font-medium mt-6">
									New here?{" "}
									<Link
										to={ROUTES.SIGINUP}
										tw="text-appPink hover:(text-appPinkSaturated)">
										Signup now
									</Link>
								</p>
							</div>
						</form>
					</div>
				</SigninWrapper>{" "}
			</div>
		</LandingLayout>
	);
};

export default Signin;
